import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, LayoutGrid, Sparkles } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 glass-header border-b border-line">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-coral text-white">
            <Sparkles size={16} strokeWidth={1.75} />
          </span>
          <span className="font-heading text-xl text-ink-900">Apúntate</span>
        </Link>

        <nav className="flex items-center gap-2">
          {user ? (
            <>
              <Button
                variant="ghost"
                className="rounded-full text-ink-700 hover:bg-cream-100"
                onClick={() => navigate("/dashboard")}
                data-testid="nav-dashboard-btn"
              >
                <LayoutGrid size={16} strokeWidth={1.75} className="mr-2" />
                Mis eventos
              </Button>
              <Button
                onClick={() => navigate("/crear")}
                className="rounded-full bg-coral hover:bg-coral-hover text-white px-5"
                data-testid="nav-create-event-btn"
              >
                Crear evento
              </Button>
              <Button
                variant="ghost"
                size="icon"
                onClick={logout}
                className="rounded-full text-ink-500 hover:bg-cream-100"
                data-testid="logout-button"
                aria-label="Cerrar sesión"
              >
                <LogOut size={16} strokeWidth={1.75} />
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="ghost"
                className="rounded-full text-ink-700 hover:bg-cream-100"
                onClick={() => navigate("/login")}
                data-testid="nav-login-btn"
              >
                Iniciar sesión
              </Button>
              <Button
                onClick={() => navigate("/registro")}
                className="rounded-full bg-coral hover:bg-coral-hover text-white px-5"
                data-testid="nav-register-btn"
              >
                Empezar gratis
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
